export const columnsTitle = {
  NAME: 'name',
  EMAIL: 'email',
  PHONE: 'phone',
  ACTIONS: 'actions'
}
